__turbopack_context__.v({
  "content_desc": "WhyChooseHealthcare-module-scss-module__Omy7rG__content_desc",
  "content_heading": "WhyChooseHealthcare-module-scss-module__Omy7rG__content_heading",
  "content_img_container": "WhyChooseHealthcare-module-scss-module__Omy7rG__content_img_container",
  "content_wrapper": "WhyChooseHealthcare-module-scss-module__Omy7rG__content_wrapper",
  "img_container2": "WhyChooseHealthcare-module-scss-module__Omy7rG__img_container2",
  "lhs": "WhyChooseHealthcare-module-scss-module__Omy7rG__lhs",
  "mh_28": "WhyChooseHealthcare-module-scss-module__Omy7rG__mh_28",
  "rhs": "WhyChooseHealthcare-module-scss-module__Omy7rG__rhs",
});
